import {checkFormField} from "./checkFormField";
import {editFormStatus} from "./editFormStatus";
import {checkEmptyFields} from "./checkEmptyFields";

export const initForms = () => {
	document.addEventListener(`keyup`, (evt) => evt.target.closest(`ul.fields`) ? checkEmptyFields(evt.target) : false);
	document.addEventListener(`change`, (evt) => evt.target.closest(`ul.fields`) ? checkEmptyFields(evt.target) : false);

	document.addEventListener(`click`, ({target}) => {
		const buttonCloseMessage = target.closest(`form div.sent button.close-message`);
		
		if ( buttonCloseMessage )
		{
			const form = target.closest(`form`);
			const inputs = Array.from(form.querySelectorAll(`input[type="text"], input[type="checkbox"]:checked, input[type="radio"]:checked, textarea, select`));
			
			inputs.forEach((input) => {
				input.classList.remove(`not-empty`);
				
				if ( input.type !== `checkbox` && input.type !== `radio` && input.value.length > 0 )
				{
					input.value = ``;
				}
				
				if ( input.checked )
				{
					input.checked = false;
				}
			});
			
			form.classList.remove(`sent`, `success`, `error`);
		}
	});
	
	document.addEventListener(`submit`, (evt) => {
		if ( evt.target.classList.contains(`ajax-form`) )
		{
			evt.preventDefault();
			const _this = evt.target;
			const formName = _this.getAttribute(`name`);

			if ( !_this.classList.contains( `on` ) )
			{
				_this.addEventListener(`keyup`, (evtKeyUp) => evtKeyUp.target.getAttribute(`data-required`) === `yes` ? checkFormField(evtKeyUp.target) : false);
				_this.addEventListener(`change`, (evtChange) => evtChange.target.getAttribute(`data-required`) === `yes` ? checkFormField(evtChange.target) : false);

				_this.classList.add( `on` );
			}

			Array.from(_this.querySelectorAll(`[data-required="yes"]`)).forEach((element) => checkFormField( element ));

			if (!_this.querySelector(`li.invalid`))
			{
				_this.classList.add( `sending` );

				const formData = new FormData(_this);
				
				// const inputs = Array.from(_this.querySelectorAll( `input:not([type="checkbox"]):not([type="radio"]), input[type="checkbox"]:checked, input[type="radio"]:checked, textarea, select` ));
				// inputs.forEach((input) => formData.append( input.name, input.value));

				/** which site query from **/
				formData.append( `location.href`, location.href);
				/** **/

				window.fetch(_this.getAttribute(`action`), {
					method: `POST`,
					credentials: `same-origin`,
					headers: {
						"X-Requested-With": `XMLHttpRequest`,
					},
					body: formData,
				})
					.then((response) => response.json())
					.then((data) => {
						/**
						 * any action
						 * **/
						
						data.error || !data.success ? editFormStatus( `error`, _this ) : editFormStatus( `success`, _this );

                        if (data.success) {
                            dataLayer.push({
                                'event': 'form_send'
                            });
                        }

						// if ( data.success && yaga_metrika !== null && yaga_ga_cat !== null && yaga_ga_act !== null && yaga_ga_label !== null )
						// {
						// 	yaga( yaga_metrika, yaga_ga_cat, yaga_ga_act, yaga_ga_label );
						// }
					})
					.catch((err) => {
						editFormStatus( `error`, _this );
					});
			}
		}
	});
};
